<template>
    <div class="personalized-quote-container send-quote-wrap">
      <div class="text-center mb-4 mt-2">
        <h5 class=""><strong>Send New Individual Personalized Quote</strong></h5>
      </div>
      <div class="row mt-2">
        <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
          <label class="text-left">First Name</label>
          <span class="required-asterisk">*</span>
          <input type="text" v-model="firstName" class="input-field" :class="{ 'form-invalid': $v.firstName.$error }"
                 placeholder="Enter First Name" />
          <div class="form-error text-left ml-3 mt-2" v-if="!$v.firstName.required && $v.firstName.$error">
            The first name field is required
          </div>
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
          <label class="label-title text-left">Last Name</label>
          <span class="required-asterisk">*</span>
          <input type="text" v-model="lastName" class="input-field" :class="{ 'form-invalid': $v.lastName.$error }"
                 placeholder="Enter Last Name" />
          <div class="form-error text-left ml-3 mt-2" v-if="!$v.lastName.required && $v.lastName.$error">
            The last name field is required
          </div>
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
          <label class="label-title mb-2">DOB</label>
          <span class="required-asterisk">*</span>
          <date-picker aria-describedby="input-feedback" placeholder="MM/DD/YYYY" @input="$v.dob.$touch();"
                       class="send-quote-date-picker" v-model="dob" :class="{ 'date-invalid': $v.dob.$error }"
                       value-type="format" format="MM/DD/YYYY">
          </date-picker>
          <div class="form-error text-left ml-3 mt-2" v-if="!$v.dob.required && $v.dob.$error">
            The dob field is required
          </div>
          <div class="form-error ml-3 mt-2" v-if="$v.dob.required && $v.dob.$error">
            You must be 18 years to proceed
          </div>
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
          <label class="label-title">Zip</label>
          <span class="required-asterisk">*</span>
          <input type="number" :class="{ 'form-invalid': $v.zip.$error }" @input="$v.zip.$touch();" v-model="zip"
                 oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                 maxlength="5" class="input-field" placeholder="Enter Zip" />
          <div class="form-error text-left ml-3 mt-2" v-if="!$v.zip.required && $v.zip.$error">
            The zip field is required
          </div>
          <div class="form-error text-left ml-3 mt-2" v-if="$v.zip.required && $v.zip.$error">
            Enter 5 digit zip code.
          </div>
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
          <label class="label-title">Tier</label>
          <span class="required-asterisk">*</span>
          <select v-model="tier" :class="{ 'form-invalid': $v.tier.$error }" class="send-custom-select  mt-1">
            <option value="" disabled>Choose Tier</option>
            <option v-for="(tier, index) in tierOptions" :value="tier.value" :key="index">{{ tier.text }}</option>
          </select>
          <div class="form-error text-left ml-3 mt-2" v-if="!$v.tier.required && $v.tier.$error">
            The tier field is required
          </div>
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
          <label class="text-left">Salary <span class="optional-text">(Optional)</span></label>
          <input type="number" v-model="salary" class="input-field" placeholder="Enter Salary" />
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
          <label class="label-title">Gender</label>
          <span class="required-asterisk">*</span>
          <select v-model="gender" :class="{ 'form-invalid': $v.gender.$error }" class="send-custom-select  mt-1">
            <option value="" disabled>Choose Gender</option>
            <option v-for="(gender, index) in genderOptions" :value="gender.value" :key="index">{{ gender.text }}
            </option>
          </select>
          <div class="form-error text-left ml-3 mt-2" v-if="!$v.gender.required && $v.gender.$error">
            The gender field is required
          </div>
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
          <label class="label-title">Email</label>
          <span class="required-asterisk">*</span>
          <input type="text" v-model="email" @input="$v.email.$touch();" class="input-field"
                 :class="{ 'form-invalid': $v.email.$error }" placeholder="Enter Email" />
          <div class="form-error text-left ml-3 mt-2" v-if="!$v.email.required && $v.email.$error">
            The email field is required
          </div>
          <div class="form-error  text-left ml-3 mt-2" v-if="$v.email.required && $v.email.$invalid">
            Enter valid email address
          </div>
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
          <label class="label-title">Enrollment Platform</label>
          <span class="required-asterisk">*</span>
          <select v-model="platform" :class="{ 'form-invalid': $v.platform.$error }"
                  class="send-custom-select  mt-1" @change="onPlatformChange">
            <option :value="null" disabled>Choose Enrollment Platform</option>
            <option v-for="(platform, index) in platformList" :value="platform" :key="index">{{ platform.text }}
            </option>
          </select>
          <div class="form-error text-left ml-3 mt-2" v-if="!$v.platform.required && $v.platform.$error">
            The platform field is required
          </div>
        </div>

        <!-- Agent Group dropdown - visible only when platform is eliteenroll.com -->
        <div class="col-xxl-4 col-lg-4 col-md-6 mb-3" v-if="isEliteEnroll">
          <label class="label-title">Agent Group</label>
          <span class="required-asterisk">*</span>
          <select v-model="selectedAgentGroup"
                  :class="{ 'form-invalid': $v.selectedAgentGroup.$error }"
                  class="send-custom-select mt-1"
                  :disabled="agentGroupsLoading">
            <option :value="null" disabled>
              {{ agentGroupsLoading ? 'Loading...' : 'Choose Agent Group' }}
            </option>
            <option v-for="(group, index) in agentGroups" :value="group" :key="index">
              {{ group.gcode }} - {{ group.gname }}
            </option>
          </select>
          <div class="form-error text-left ml-3 mt-2" v-if="!$v.selectedAgentGroup.required && $v.selectedAgentGroup.$error">
            The agent group field is required
          </div>
        </div>

          <!--dependent information-->
        <div v-if="tier.length && tier!=='IO'">
          <div class="row">
            <div class="col-xxl-4 col-lg-4 col-md-6 mb-3" v-if="tier === 'IS' || tier==='IF'" >
              <label class="label-title mb-2">DOB (Spouse / Partner)</label>
              <span class="required-asterisk">*</span>
              <date-picker aria-describedby="input-feedback" placeholder="MM/DD/YYYY" @input="$v.spouseDob.$touch();"
                           class="send-quote-date-picker" v-model="spouseDob" :class="{ 'date-invalid': $v.spouseDob.$error }"
                           value-type="format" format="MM/DD/YYYY">
              </date-picker>
              <div class="form-error text-left ml-3 mt-2" v-if="!$v.spouseDob.required && $v.spouseDob.$error">
                The spouse dob field is required
              </div>
              <div class="form-error ml-3 mt-2" v-if="$v.spouseDob.required && $v.spouseDob.$error">
                Spouse age must be at least 18 years
              </div>
            </div>
            <div class="col-xxl-4 col-lg-4 col-md-6 mb-3" v-if="tier === 'IC' || tier === 'IF'">
              <label class="text-left">Children</label>
              <span class="required-asterisk">*</span>
              <input type="number" v-model="childNumber" class="input-field" placeholder="Enter Number Of Children" @input="$v.childNumber.$touch();"
                     :class="{ 'form-invalid': $v.childNumber.$error }"/>
              <div class="form-error text-left ml-3 mt-2" v-if="!$v.childNumber.required && $v.childNumber.$error">
                The children field is required
              </div>
              <div class="form-error ml-3 mt-2" v-else-if="!$v.childNumber.greaterThanZero">
                The number of children must be 0 (min) and 8 (max)
              </div>
              <div class="form-error ml-3 mt-2" v-else-if="$v.childNumber.required && !$v.childNumber.isWholeNumber">
                The number can't be negative or decimal
              </div>
            </div>
          </div>
        </div>
  
  
          <!--Go to next step button-->
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 d-flex justify-content-end">
          <button type="submit" @click="goToNextStep" class="new-quote-btn mt-0">Next</button>
        </div>
  <!--      </div>-->
      </div>
    </div>
  </template>
  
  <script>
  import {email, required} from "vuelidate/lib/validators";
  import {checkValidZip, isOver18} from "../../../../utils/validator";
  import Api from "../../../../resource/Api";
  // import {useVuelidate} from "@vuelidate/core";
  
  
  export default {
    name: 'BasicDetailsSubmit',
    validations: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      dob: {
        required,
        isOver18
      },
      zip: {
        required,
        checkValidZip
      },
      tier: {
        required
      },
      gender: {
        required
      },
      email: {
        required,
        email
      },
      platform: {
        required
      },
      spouseDob: {
        required,
        isOver18,
      },
      childNumber: {
        required,
        greaterThanZero: (value) => value >= 0 && value <=8,
        isWholeNumber: (value) => Number.isInteger(Number(value)),
      },
      selectedAgentGroup: {
        required(value) {
          // Only required when eliteenroll.com platform is selected
          if (this.isEliteEnroll) {
            return value !== null && value !== undefined;
          }
          return true;
        },
      },
    },
    data(){
      return {
        firstName: '',
        lastName: '',
        dob: '',
        zip: '',
        tier: '',
        salary: '',
        platform: null,
        platformName: '',
        email: '',
        gender: '',
        platformList: [],
        selectedPlanOptions: [],
        selectedPlanId: [],
        selectedCategoryOptions: [],
        selectedCategory: [],
        spouseDob: '',
        errorMessage: null,
        childNumber: null,
        tierOptions: [
          { value: 'IO', text: 'Member Only' },
          { value: 'IS', text: 'Member + Spouse' },
          { value: 'IC', text: 'Member + Children' },
          { value: 'IF', text: 'Family' }
        ],
        genderOptions: [
          { value: 'M', text: 'Male' },
          { value: 'F', text: 'Female' }
        ],
        agentGroups: [],
        selectedAgentGroup: null,
        agentGroupsLoading: false,
      }
    },
      computed: {
        isEliteEnroll() {
          return this.platform && this.platform.text && this.platform.text.toLowerCase() === 'eliteenroll.com';
        },
      },
      methods: {
        fetchAgentGroups() {
          this.agentGroupsLoading = true;
          const agentId = this.$store.getters.repId;
          const currentPlatformValue = this.platform.value;
          let url = 'v2/quote/get-agent-groups';
          const params = [];
          if (agentId) params.push(`agent_id=${agentId}`);
          if (currentPlatformValue) params.push(`platform_id=${currentPlatformValue}`);
          if (params.length) url += '?' + params.join('&');
          return Api.get(url).then((response) => {
            this.agentGroups = response.data.data.data || [];
          }).catch(() => {
            this.agentGroups = [];
          }).finally(() => {
            this.agentGroupsLoading = false;
          });
        },

        onPlatformChange() {
          // Reset agent group when platform changes
          this.selectedAgentGroup = null;
          if (this.isEliteEnroll) {
            this.fetchAgentGroups();
          }
        },

        saveEnrollmentTemp(payload) {
          let loader = this.$loading.show();
          return Api.post('v2/quote/save-enrollment-temp', payload).then((response) => {
            this.$store.commit('setEnrollmentId', response.data.message);
  
            const basicDetails = payload;
            basicDetails["dep_dob"] = this.spouseDob ? this.convertDateFormat(this.spouseDob) : '';
            basicDetails["no_of_children"] = this.childNumber ? this.childNumber : '';
  
            this.$store.commit('setBasicIndividualDetails', basicDetails)
            return response;
          }).catch((error) => {
            this.$notify(error.response.data.message, "error");
          }).finally(() => {
            loader.hide();
          })
        },
  
        convertDateFormat(dateStr) {
          const [month, day, year] = dateStr.split('/');
          return `${year}/${month}/${day}`;
        },
  
        convertSpouseDobFormat(dateStr){
          const [year, month, day] = dateStr.split('/');
          return `${month}/${day}/${year}`;
        },
  
        //get plans and categories based on enrollment id
        getPlansAndCategories() {
          const enrollmentId = this.$store.getters.enrollmentId;
          let url;
          let spousedob =  this.spouseDob ? this.convertDateFormat(this.spouseDob) : '';
          if (this.tier == 'IC') {
            url = `v2/quote/get-plan-category?enrollment_id=${enrollmentId}&no_of_children=${this.childNumber}`;
          } else if (this.tier == 'IS') {
            url = `v2/quote/get-plan-category?enrollment_id=${enrollmentId}}&dep_dob=${spousedob}`;
          } else if (this.tier == 'IF') {
            url = `v2/quote/get-plan-category?enrollment_id=${enrollmentId}&dep_dob=${spousedob}&no_of_children=${this.childNumber}`;
          } else {
            url = `v2/quote/get-plan-category?enrollment_id=${enrollmentId}`;
          }
          const loader = this.$loading.show();
          Api.get(url).then((response) => {
            const planData = response.data.data;
            //update store
            this.$store.commit('setPlanData', planData);
            this.$store.commit('setPlanCategories');
            this.$store.commit('setCurrentIndividualQuoteStep', 1);
          }).catch((error) => {
            this.$notify(error.response.data.message, "error");
          }).finally(() => {
            loader.hide();
          })
        },
  
  
        isFormValid(validationObject) {
          const defaultFields = ['firstName', 'lastName', 'dob', 'tier', 'zip', 'platform', 'email', 'gender'];
          const areDefaultFieldsInvalid = defaultFields.every(field => validationObject[field]["$error"]);
          const agentGroupInvalid = this.isEliteEnroll && validationObject["selectedAgentGroup"]["$error"];

          if (this.tier === "IO") {
            return !areDefaultFieldsInvalid && !agentGroupInvalid;
          }
          else if (this.tier === "IS") {
            return !areDefaultFieldsInvalid && !validationObject["spouseDob"]["$error"] && !agentGroupInvalid;
          }
          else if (this.tier === "IC") {
            return !areDefaultFieldsInvalid && !validationObject["childNumber"]["$error"] && !agentGroupInvalid;
          }
          else if (this.tier === "IF") {
            return !areDefaultFieldsInvalid &&
                !validationObject["spouseDob"]["$error"] &&
                !validationObject["childNumber"]["$error"] &&
                !agentGroupInvalid;
          }
          return false;
        },
  
        //handle next step navigation
        goToNextStep() {
          this.$v.$touch();
          if (!this.isFormValid(this.$v)) {
            return false;
          } else {
            this.$v.$reset();
            const currentPlatformValue = this.platform.value;
            const portal = this.platformList.filter(platform => platform.value === currentPlatformValue)[0].text;
            // update store if the information is valid
            const payload = {
              member_fname: this.firstName,
              member_lname: this.lastName,
              dob: this.dob,
              zip_code: this.zip,
              tier: this.tier,
              salary: this.salary,
              gender: this.gender,
              email: this.email,
              portal: portal,
            }

            if (this.isEliteEnroll && this.selectedAgentGroup) {
              //payload.agent_group_id = this.selectedAgentGroup.gid;
              payload.agent_group_code = this.selectedAgentGroup.gcode;
            }


            this.saveEnrollmentTemp(payload).then((response) => {
              if (response.status === 200){
                this.getPlansAndCategories();
              }
            });
          }
        },
  
        setFormDetails() {
          const individualDetails = this.$store.getters.individualDetails;
  
          if (Object.keys(individualDetails).length > 0) {
            this.firstName = individualDetails.member_fname;
            this.lastName = individualDetails.member_lname;
            this.dob = individualDetails.dob;
            this.tier = this.tierOptions.find(item => item.text === individualDetails.tier || item.value === individualDetails.tier)["value"];
            this.gender = this.genderOptions.find(gender => gender.text === individualDetails.gender || gender.value === individualDetails.gender)["value"];
            this.zip = individualDetails.zip_code;
            this.salary = individualDetails.salary;
            this.email = individualDetails.email;
            this.platform = this.platformList.find(item => item.text === individualDetails.portal || item.value === individualDetails.portal);
            this.spouseDob = individualDetails.dep_dob ? this.convertSpouseDobFormat(individualDetails.dep_dob) : '';
            this.childNumber = individualDetails.no_of_children ? individualDetails.no_of_children : null;

            // If restoring eliteenroll platform, load agent groups and restore selection
            if (this.isEliteEnroll) {
              this.fetchAgentGroups().then(() => {
                if (individualDetails.agent_group_code) {
                  this.selectedAgentGroup = this.agentGroups.find(g => g.gcode === individualDetails.agent_group_code) || null;
                }
              });
            }
          }
        },
      },
      created() {
        this.platformList = this.$store.getters.enrollmentPlatforms;
        this.setFormDetails();
      },
  }
  </script>
  
  <style scoped>
  .new-quote-btn{
    max-width: fit-content;
  }
  
  .custom-input {
    width: 100%;
    border: 1px solid #dddddd;
    border-radius: 6px;
    font-size: 14px;
    padding: 10px 15px;
    outline: none;
  }
  
  </style>